import { Inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { BehaviorSubject } from 'rxjs';
import { AdminHttpProxyService } from './admin-http-proxy.service';

@Injectable({
  providedIn: 'root',
})
export class InitService {
  public tenantId: string;
  public propertyID = new BehaviorSubject<any>('default');
  public propertyPermissions = new BehaviorSubject<any>('default');
  public cloudDomain = new BehaviorSubject<any>('default');
  public userUpdatedPicture = new BehaviorSubject<any>('default');
  public routeTriggerMessage = new BehaviorSubject<any>('default');
  public cloudBackendDomain: string = environment.backendApiUrl;
  public cloudContextTenants: any;
  public appName = new BehaviorSubject<any>('default');
  public cloudDomaindata: any;
  public tenant: any = '';
  public serviceHeaders: any;
  public configUrl: string = 'wbe-property-service/property';
  constructor(public httpService: AdminHttpProxyService) {}

  ngOnInit() {}

  updateTenantId(id) {
    this.tenantId = id;
  }

  getTenantId() {
    return this.tenantId;
  }

  updatePropertyId(id) {
    this.propertyID.next(id);
  }

  getPropertyId() {
    return this.propertyID;
  }

  updatePropertyPermissions(details) {
    this.propertyPermissions.next(details);
    this.appName.next(details['productName'] == 'rGuest_Book' ? 'wbe' : 'cico');
  }

  getPropertyPermissions() {
    return this.propertyPermissions;
  }

  getAppName() {
    return this.appName;
  }

  checkDomain() {
    if (!environment.showLogs) {
      if (window) {
        window.console.log = function () {};
      }
    }
  }

  public getCloudDomainName = function () {
    return this.cloudBackendDomain;
  };

  getPropertyConfig(tenantId, propertyId, appName) {
    let url =
      environment.backendApiUrl + '/' + this.configUrl + '/tenants/' + tenantId + '/propertyId/' + propertyId + '/appName/' + appName;
    return this.httpService.get(url);
  }
}
